import { Observable, Observer } from 'rxjs';
import SockJS from 'sockjs-client';
import * as Stomp from 'webstomp-client';
import ChatRoom from './index.vue';


export default class ChatRoomService {
    public stompClient: Stomp.Client = null;
    public subscriber: any = null;
    public connection: Promise<any>;
    public connectedPromise: any = null;
    public listener: Observable<any>;
    public listenerObserver: Observer<any> = null;
    public alreadyConnectedOnce = false;
    public chatRoom: ChatRoom= null;

    private roomId: any= "";

    constructor(chatRoom: ChatRoom){
        this.chatRoom= chatRoom;
        this.connection = this.createConnection();
        this.listener = this.createListener();
    }

    public connect(roomId): void {

        this.roomId= roomId;
        if (this.connectedPromise === null) {
          this.connection = this.createConnection();
        }
        // building absolute path so that websocket doesn't fail when deploying with a context path
        const loc = window.location;
        let url = `//${loc.host}${loc.pathname}websocket/chat`;
        const authToken = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
        if (authToken) {
          url += '?access_token=' + authToken;
        }
        const socket = new SockJS(url);
        this.stompClient = Stomp.over(socket);
        this.stompClient.debug=() => {};
        this.stompClient.connect(this.buildHeaders(authToken), (res) => {
          console.log(" connection done : ", {res});
          this.afterConnect();
        }, (e)=> {
          console.log("connection socket error", {e});
        });
      }
    
      public afterConnect() {
        this.connectedPromise('success');
        this.connectedPromise = null;
        if (!this.alreadyConnectedOnce) {
          this.alreadyConnectedOnce = true;
        }

        this.subscribe(this.roomId);
      }
    
      public disconnect(): void {
        if (this.stompClient !== null) {
          this.stompClient.disconnect();
          this.stompClient = null;
        }
        this.alreadyConnectedOnce = false;
      }
    
      public receive(): Observable<any> {
        return this.listener;
      }

      refresh(): void {
          (<any>this.chatRoom).refresh();
      }
    
      public subscribe(socketId: string): void {
          console.log(" do subscribe ");
          
          this.subscriber = this.stompClient.subscribe('/topic/messages', data => {
            console.log("chat subscribe data : ", {data});
            this.listenerObserver.next(JSON.parse(data.body));
          }, this.buildHeaders());

        // this.connection.then(() => {
          
        // });
      }
    
      public unsubscribe(): any {
        if (this.subscriber !== null) {
          this.subscriber.unsubscribe();
        }
      }
    
      public createListener(): any {
        return new Observable(observer => {
          this.listenerObserver = observer;
        });
      }
    
      public createConnection(): Promise<any> {
        return new Promise(resolve => (this.connectedPromise = resolve));
      }
    
      private buildHeaders(token: string = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken')) {
        return token ? { Authorization: token } : {};
      }

      public sendMessage(message: any): void {
          if(this.stompClient !== null && this.stompClient.connected) {
              console.log("sending message ", {message});
              this.stompClient.send("/topic/send", JSON.stringify(message), this.buildHeaders());
          }
      }
}